import React from "react";
import {
  Box,
  Logo,
  Copyright
} from "./styles";
  
function Footer () {
  return (
    <Box>
      <Logo> TAON </Logo>
      <Copyright> © 2022- TAON Filmes e Séries. Todos os direitos reservados. </Copyright>
    </Box>
  );
};
export default Footer;